import BoxCountChart from './BoxCountChart';
import BoxTimingChart from './BoxTimingChart';
import BoxMissPickChart from './BoxMissPickChart';
import BoxStatusList from './BoxStatusList';
import PickQaStats from './PickQaStats';
import Pickup from './Pickup';
import ShippedStats from './ShippedStats';
import UserBoxStats from './UserBoxStats';
import ProductionQueue from './ProductionQueue';

const widgets = [
  BoxCountChart,
  BoxTimingChart,
  BoxMissPickChart,
  BoxStatusList,
  PickQaStats,
  Pickup,
  ShippedStats,
  UserBoxStats,
  ProductionQueue
];

const grids = [];
grids.push({
  name: '1x1',
  parts: [{ type: 'holder', width: '100%', height: '100%' }]
});
grids.push({
  name: '3x1',
  parts: [
    { type: 'holder', width: '33%', height: '100%' },
    { type: 'holder', width: '33%', height: '100%' },
    { type: 'holder', width: '33%', height: '100%' }
  ]
});
grids.push({
  name: '3x2',
  parts: [
    { type: 'holder', width: '33%', height: '50%' },
    { type: 'holder', width: '33%', height: '50%' },
    { type: 'holder', width: '33%', height: '50%' },
    { type: 'clear' },
    { type: 'holder', width: '33%', height: '50%' },
    { type: 'holder', width: '33%', height: '50%' },
    { type: 'holder', width: '33%', height: '50%' }
  ]
});
grids.push({
  name: '1x2 + 1*3',
  parts: [
    { type: 'holder', width: '59%', height: '35%' },
    { type: 'holder', width: '40%', height: '35%' },
    { type: 'clear' },
    { type: 'holder', width: '33%', height: '65%' },
    { type: 'holder', width: '33%', height: '65%' },
    { type: 'holder', width: '33%', height: '65%' }
  ]
});

export default { widgets, grids };



// WEBPACK FOOTER //
// ./app/widgets.new/index.js